import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { ApplicationPackage } from './application-package.service';

@Injectable({
  providedIn: 'root'
})
export class PermitVarianceService {

  private varianceSource = new BehaviorSubject<PermitVarianceFormData>(null);
  currentVariance = this.varianceSource.asObservable();

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getVariance(varianceId: number) {
    this.http.get<PermitVarianceApiData>(`${this.baseUrl}api/permitvariance/${varianceId}`).subscribe(
      response => {
        if (response) {
          this.changeVariance(this.generateVarianceFormData(response));
        } else {
          this.changeVariance(null);
        }
      },
      error => console.error(error)
    );
  }

  putVariance(formData: PermitVarianceFormData, applicaitonPackage: ApplicationPackage) {
    let apiData = this.generateVarianceApiData(formData, applicaitonPackage);
    apiData.permitVarianceId = applicaitonPackage.permitVarianceId;
    this.http.put<PermitVarianceApiData>(`${this.baseUrl}api/permitvariance`, apiData).subscribe(
      response => {
        if (response) {
          this.changeVariance(this.generateVarianceFormData(response));
        } else {
          this.changeVariance(null);
        }
      },
      error => console.error(error)
    );
  }

  postVariance(formData: PermitVarianceFormData, applicaitonPackage: ApplicationPackage) {
    let apiData = this.generateVarianceApiData(formData, applicaitonPackage);
    this.http.post<PermitVarianceApiData>(`${this.baseUrl}api/permitvariance`, apiData).subscribe(
      response => {
        if (response) {
          this.changeVariance(this.generateVarianceFormData(response));
        } else {
          this.changeVariance(null);
        }
      },
      error => console.error(error)
    );
  }

  generateVarianceApiData(data: PermitVarianceFormData, applicationPackage: ApplicationPackage) {
    const newVarianceData: PermitVarianceApiData = {
      //id is not used here because for POSTing, we don't know the id yet.
      applicationPackageId: applicationPackage.applicationPackageId,
      permitPointOfDiversionId: applicationPackage.permitPointOfDiversionId,
      // PermitYearId?: number,
      description: data.description,
      projForNonConsumptiveUse: data.check1 || false,
      ifProjForConsumptivePlanNoHarm: data.check2 || false,
      hasInfoAboutDepletion: data.check3 || false,
      existedPriorToMoratorium: data.check4 || false,
      addressesSafetyIssue: data.check5 || false,
      useIsTemporary: data.check6 || false,
      exampleDocFileUploadListId: data.narrativeFile, // will eventually be a file upload?
      // petitionerApplicant: data.name
      // missing address, email, phone, and additional contact
      analysisFileUploadListId: data.analysisFileUploadListId,
      criteriaSupportFileUploadListId: data.criteriaSupportFileUploadListId,
      useDNRReport: data.useDNRReport
    };
    return newVarianceData;
  }

  generateVarianceFormData(data: PermitVarianceApiData) {

    const newVarianceData: PermitVarianceFormData = {
      permitVarianceId: data.permitVarianceId,
      applicationPackageId: data.applicationPackageId,
      podId: data.permitPointOfDiversionId,
      // PermitYearId?: number,
      description: data.description,
      check1: data.projForNonConsumptiveUse,
      check2: data.ifProjForConsumptivePlanNoHarm,
      check3: data.hasInfoAboutDepletion,
      check4: data.existedPriorToMoratorium,
      check5: data.addressesSafetyIssue,
      check6: data.useIsTemporary,
      narrativeFile: data.exampleDocFileUploadListId, // will eventually be a file upload?
      // name: data.petitionerApplicant
      // missing address, email, phone, and additional contact
      canEdit: data.canEdit,
      analysisFileUploadListId: data.analysisFileUploadListId,
      criteriaSupportFileUploadListId: data.criteriaSupportFileUploadListId,
      useDNRReport: data.useDNRReport
    }

    return newVarianceData;
  }

  changeVariance(variance: PermitVarianceFormData) {
    this.varianceSource.next(variance);
  }
}

export interface PermitVarianceApiData {
  permitVarianceId?: number,
  applicationPackageId: number,
  permitPointOfDiversion?: string, // 
  permitPointOfDiversionId: number, // Grab from service/POD
  permitYear?: number, // When/how will this be implimented?
  permitYearId?: number, // When/how will this be implimented?
  description: string, // description
  projForNonConsumptiveUse: boolean, // check1
  ifProjForConsumptivePlanNoHarm: boolean, // check2
  hasInfoAboutDepletion: boolean, // check3
  existedPriorToMoratorium: boolean, // check4
  addressesSafetyIssue: boolean, // check5
  useIsTemporary: boolean, // check6
  exampleDocFileUploadListId: number, // will eventually be a file upload?
  // petitionerApplicant: string, // name
  approvedByUserId?: string,
  approvedDateTime?: any,
  // missing address, email, phone, and additional contact
  canEdit?: boolean,
  analysisFileUploadListId: number,
  criteriaSupportFileUploadListId: number,
  useDNRReport: boolean
}

export interface PermitVarianceFormData {
  permitVarianceId?: number,
  applicationPackageId: number,
  podId: number,
  // PermitYearId?: number,
  description: string,
  check1: boolean,
  check2: boolean,
  check3: boolean,
  check4: boolean,
  check5: boolean,
  check6: boolean,
  narrativeFile: number, // will eventually be a file upload?
  // missing address, email, phone, and additional contact
  // name: string
  canEdit: boolean,
  analysisFileUploadListId: number,
  criteriaSupportFileUploadListId: number,
  useDNRReport: boolean
}
